<template>
    <span>
        <v-snackbar v-model="snackbar" :timeout="10000" top color="red">
            <span>Incorrect Login Details</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar1" :timeout="10000" top color="red">
            <span>{{snackmsg}}</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="dialog" width="500" persistent>
            <v-card class="pa-12 mx-auto" id="login" max-width="500" elevation="7">
                <v-system-bar light color="#ffffff" class="mt-n5">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialog=false">
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                </v-system-bar>
                <div class="text-center mt-5 mb-4" style="color:#1a00d4">Log in to your account</div>
                <v-card-text>
                    <v-form>
                        <v-text-field outlined dense label="Email"  prepend-inner-icon="mdi-account" name="username" v-model="username" type="text" color="#1a00d4">

                        </v-text-field>
                        <v-text-field outlined dense class="mt-7" label="Password" name="password" v-model="password"
                            :append-icon="show1 ? 'visibility' : 'visibility_off'" color="#1a00d4"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="show1 = !show1"
                            prepend-inner-icon="mdi-lock"
                            >
                        </v-text-field>
                        <v-card-text class="text-right">
                        <v-btn text class="forgot mt-n9" @click="forget()">Forgot Password?</v-btn>
                    </v-card-text>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <div class="mx-auto">
                        <v-btn width="350" large dark color="#1a00d4" :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" v-on:click="login()">
                            Login
                        <v-icon right>mdi-login</v-icon>
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-navigation-drawer app clipped-left floating v-model="drawer" class="nav brown lighten-2" dark disable-resize-watcher>
            <v-layout column align-center>
                <v-flex class="mt-6">
                    <div class="pa-3 mr-2">
                    <v-img src="/simbolo_bitcoin.jpg" cover width="100px" height="60px" @click="home()" style="pointer:cursor"></v-img>
                    </div>
                </v-flex>
          </v-layout>
          
          <v-layout column align-center>
                <v-flex class="white--text" dark>
                    Welcome, {{user}}
                </v-flex>
          </v-layout>
          <v-layout column align-center>
                <v-flex class="black--text font-weight-bold" dark>
                    {{BtcRate}} BTC/USD
                </v-flex>
          </v-layout>
          <v-list dense nav class="mt-12" >
              <v-list-item router-link to="/home">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-home</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  HOME
                </v-list-item-title> 
                
              </v-item-content>
            </v-list-item>
            <v-list-item router-link to="/earncrypto">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  EARN CRYPTO
                </v-list-item-title>
                
              </v-item-content>
            </v-list-item>

            <v-list-item router-link to="/importwishlist">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-swap-vertical</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  IMPORT WISH LIST
                </v-list-item-title>
                
              </v-item-content>
            </v-list-item>
            <v-list-item router-link to="/login" v-if="isUserLogged===false">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-login</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  LOGIN
                </v-list-item-title>
                
              </v-item-content>
            </v-list-item>
            <v-list-item router-link to="/orders" v-if="isUserLogged===true&isUserVerified===1">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-cart</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  ORDERS                   <v-btn icon x-small style="border: 1px red solid" class="ml-2" v-if="profile.messageCount>0">{{profile.messageCount}}</v-btn>

                </v-list-item-title>
                
              </v-item-content>
            </v-list-item>
            <v-list-item router-link to="/wallet" v-if="isUserLogged===true&isUserVerified===1">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-wallet</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  WALLET
                </v-list-item-title>
                
              </v-item-content>
            </v-list-item>
            <!-- <v-list-item router-link to="" v-if="isUserLogged===true">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-account</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  MY ACCOUNT
                </v-list-item-title>
                
              </v-item-content>
            </v-list-item> -->

            <v-list-group v-if="isUserLogged===true">
              <template v-slot:activator>
                <v-list-item-icon class="ml-5">
                  <v-icon color="#B45C5C">mdi-account</v-icon>
                </v-list-item-icon>
                <v-item-content>
                  <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                    MY ACCOUNT
                  </v-list-item-title>
                </v-item-content>
              </template>
              <v-list-item router-link to="/profile" class="ml-5">
                <v-list-item-icon>
                  <v-icon color="#B45C5C">mdi-account</v-icon>
                </v-list-item-icon>
                <v-item-content>
                  <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                    MY PROFILE
                  </v-list-item-title> 
                </v-item-content>
              </v-list-item>
              <v-list-item router-link to="/transactionhistory" class="ml-5">
                <v-list-item-icon>
                  <v-icon color="#B45C5C">mdi-finance</v-icon>
                </v-list-item-icon>
                <v-item-content>
                  <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                    TRANSACTION HISTORY
                  </v-list-item-title> 
                </v-item-content>
              </v-list-item>
              <v-list-item @click="logout()" class="ml-5">
                <v-list-item-icon>
                  <v-icon color="#B45C5C">mdi-logout</v-icon>
                </v-list-item-icon>
                <v-item-content>
                  <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                    LOGOUT
                  </v-list-item-title> 
                </v-item-content>
              </v-list-item>
              
            </v-list-group>





            <v-list-item @click="logout()" v-if="isUserLogged===true">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  LOGOUT
                </v-list-item-title>
                
              </v-item-content>
            </v-list-item>
            <v-list-item router-link to="/signup" v-if="isUserLogged===false">
              <v-list-item-icon>
                <v-icon color="#B45C5C">mdi-account-plus</v-icon>
              </v-list-item-icon>
              <v-item-content>
                <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                  REGISTER
                </v-list-item-title>
                
              </v-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>



        <v-toolbar app color="#444444" dark flat>
            <v-app-bar-nav-icon color="#fffff" @click="drawer = !drawer" class="hidden-md-and-up"></v-app-bar-nav-icon>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <v-toolbar-title class="hidden-sm-and-down" @click="home()" style="cursor:pointer">
                <v-img src="/simbolo_bitcoin.jpg" cover width="100px" height="60px"></v-img>
            </v-toolbar-title> 
                <h1 class="white--text" @click="home()" style="cursor:pointer">BITSHOPY</h1>
                <v-subheader class="green--text px-12  hidden-md-and-down">{{BtcRate}} BTC/USD</v-subheader>
                <v-spacer></v-spacer>
                <v-btn class="ma-2 hidden-sm-and-down" color="#333333" router-link to="/earncrypto" dark>EARN CRYPTO</v-btn>
                <v-btn class="ma-2 hidden-sm-and-down" color="#333333" router-link to="/importwishlist" dark>IMPORT WISH LIST</v-btn>
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn class="ma-2 hidden-sm-and-down" color="#333333" dark @click="dialog=true" v-if="isUserLogged===false">LOGIN</v-btn>
                <v-btn class="ma-2 hidden-sm-and-down" color="#333333" dark  router-link to="/orders" v-if="isUserLogged===true&isUserVerified===1">
                  
                  ORDERS
                  <v-btn icon x-small style="border: 1px red solid" class="ml-1 mt-1" v-if="profile.messageCount>0">{{profile.messageCount}}</v-btn>
                </v-btn>
                <v-btn class="ma-2 hidden-sm-and-down" color="#333333" dark   router-link to="/wallet" v-if="isUserLogged===true&isUserVerified===1">WALLET</v-btn>
                <v-menu bottom left v-if="isUserLogged===true&isUserVerified===1">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="ma-2 hidden-sm-and-down" color="#333333" dark  v-if="isUserLogged===true&isUserVerified===1">MY ACCOUNT <v-icon small class="white--text mt-1 mx-1">mdi-chevron-down</v-icon></v-btn>
                    
                  </template>

                  <v-list  style="background-color:#444444">
                    <v-list-item router-link to="/profile">
                      <v-list-item-icon>
                        <v-icon color="white">mdi-account</v-icon>
                      </v-list-item-icon>
                      <v-item-content>
                        <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                          MY PROFILE
                        </v-list-item-title> 
                      </v-item-content>
                    </v-list-item>
                    <v-list-item router-link to="/transactionhistory">
                      <v-list-item-icon>
                        <v-icon color="white">mdi-finance</v-icon>
                      </v-list-item-icon>
                      <v-item-content>
                        <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                          TRANSACTION HISTORY
                        </v-list-item-title> 
                      </v-item-content>
                    </v-list-item>
                    <v-list-item @click="logout()">
                      <v-list-item-icon>
                        <v-icon color="white">mdi-logout</v-icon>
                      </v-list-item-icon>
                      <v-item-content>
                        <v-list-item-title style="color:#FFFFFF; font-size:14px" >
                          LOGOUT
                        </v-list-item-title> 
                      </v-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <!-- <v-btn class="ma-2 hidden-sm-and-down" color="#333333" dark  v-if="isUserLogged===true">MY ACCOUNT</v-btn> -->
                <!-- <v-btn class="ma-2 hidden-sm-and-down" color="#333333" dark @click="logout()" v-if="isUserLogged===true">LOGOUT</v-btn> -->
                <v-btn class="ma-2 hidden-sm-and-down" color="#333333" dark v-if="isUserLogged===false" router to="/signup">REGISTER</v-btn>
                <v-spacer></v-spacer>

        </v-toolbar>
        <v-system-bar color="#444444" dark class="mb-1 hidden-sm-and-down" v-if="isUserLogged===true&isUserVerified===1">
          <v-spacer></v-spacer>
          <v-icon color="orange">mdi-bitcoin</v-icon>
          <span class="red--text mr-2" >BALANCE</span> 
          <span class="red--text">{{profile.walletBalanceBtc}} BTC=</span>
          <span class="red--text">{{profile.walletBalanceUsd}} USD</span>

          <!-- <v-subheader class="green--text px-12  hidden-md-and-down">{{BtcRate}} BTC/USD</v-subheader> -->
          <v-spacer></v-spacer> 
          <v-spacer></v-spacer> 
        </v-system-bar>
        <v-system-bar color="#444444" dark class="mb-1 hidden-md-and-up" v-if="isUserLogged===true&isUserVerified===1">
          <v-spacer></v-spacer>
          <v-icon color="orange">mdi-bitcoin</v-icon>
          <span class="red--text mr-2" >BALANCE</span> 
          <span class="red--text">{{profile.walletBalanceBtc}} BTC=</span>
          <span class="red--text">{{profile.walletBalanceUsd}} USD</span>

          <!-- <v-subheader class="green--text px-12  hidden-md-and-down">{{BtcRate}} BTC/USD</v-subheader> -->
          <!-- <v-spacer></v-spacer>  -->
          <v-spacer></v-spacer> 
        </v-system-bar>
    </span>
</template>

<script>
export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            username:"",
            password:"",
            show1: false,
            loading: false,
            snackbar:false,
            snackbar1:false,
            snackmsg:'',
            dialog:false,
        };
    },
    methods:{
        home(){
            this.$router.push('/home')
        },
        forget(){
          this.dialog=false
          this.$router.push('/forgotpassword')
        },
        login(){
            this.loading = true
            this.$store.dispatch("Login", {
            "email": this.username,
            "password": this.password
            })
            .then((success)=>{
            console.log(success);
            this.loading = false
            this.dialog = false
            this.$router.push('/'); 
            })
            .catch((error)=>{
            console.log(error);
            if(error.response.status===400){
              this.loading = false;
              this.dialog= false
              this.snackbar = true;
            }else{
              this.loading = false
              this.dialog = false
              this.snackmsg = error.response.data.mesage
              this.snackbar1 = true;
            }
            
            });
        },
        logout(){
          this.$store.dispatch("AUTH_LOGOUT")
          .then(()=>{
            window.localStorage.removeItem("vuex")
            this.isUserLogged= this.$store.state.auth.isUserLogged
            this.$router.push('/login');
          })
          .catch((error)=>{
            console.log(error);
          })
      },
    },
    computed:{
      isUserLogged(){
        return this.$store.state.auth.isUserLogged
      },
      isUserVerified(){
        return this.$store.state.auth.logindetails.isVerified
      },
      user(){
        return this.$store.state.auth.logindetails.username
      },
      profile(){
        let profile= this.$store.state.auth.logindetails
        profile.walletBalanceBtc = parseFloat(profile.walletBalanceBtc).toFixed(8)
        profile.walletBalanceUsd = parseFloat(profile.walletBalanceUsd).toFixed(2)
        return profile
      },
      BtcRate(){
        let btc= this.$store.state.offer.BtcRate
        if(btc){
          return btc.toFixed(8)
        }
        return ''
      },
    },
    created(){
      this.$store.dispatch("GetBtcRate")
      .then(()=>{
        
      })
      .catch((error)=>{
        console.log(error);
      })
    }
};
</script>

<style scoped>
/* .v-list .v-list-item--active{ */
  /* background-color: ; */
/* } */
.nav{
    box-shadow: 0px 14px 8px rgba(0, 0, 0, 0.25);
}

</style>